export class AdjustmentTypeModalPayload {
  adjustmentTypeId: number;
  tbaId: number;
}
